import { useMutation } from '@tanstack/react-query'
import { PulseFilters } from 'api/pulse'
import { getFillRateTimeseriesCsv } from 'api/pulse/fillRateTimeseries'
import fileDownload from 'js-file-download'
import { track } from 'lib/amplitude'

export function useFillRateTimeseriesDownloadCsv(query: PulseFilters) {
  return useMutation({
    mutationFn: async () => {
      track('button_click, pulse_download_csv_fill_rate_timeseries', {
        filters: query,
      })
      const data = await getFillRateTimeseriesCsv(query)
      fileDownload(data, 'fill_rate_timeseries.csv')
    },
  })
}
